import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';

import { initAnalytics } from 'utils/analytics';

import App from './App';
import * as serviceWorker from './serviceWorker';

const { REACT_APP_SENTRY_DSN, REACT_APP_SENTRY_ENVIRONMENT } = process.env;

initAnalytics();

Sentry.init({
  dsn: REACT_APP_SENTRY_DSN,
  environment: REACT_APP_SENTRY_ENVIRONMENT,
  // These errors *seem* to be harmless and provide little helpful information.
  // If in the future some hard-to-debug front-end bug crops up, it might
  // be worthwhile removing this ignore rule to see if it's being hidden.
  // See: https://github.com/getsentry/sentry-javascript/issues/2546#issuecomment-1727939255
  ignoreErrors: ['Non-Error promise rejection captured'],
});

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <StrictMode>
    <App />
  </StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
